import { gql } from '@apollo/client';
const isSharedDocument = gql `
  query GetIsSharedDocument($id: String!) {
    invites: externalSharingInvites(where: { fileSystemDocumentId: { eq: $id } }) {
      id
    }
  }
`;
export { isSharedDocument };
